const app = {
  projectFallback: "Project",
};

export default app;
